module.exports = __webpack_public_path__ + "img/imgselcardtitle.556dfe55.png";